import { useExperiments } from '../../contexts/experiments-context';
import { EXPERIMENTS } from '../../constants';
import { ForcedState, useForcedState } from '../../contexts/forced-state-context';
import { useTpaStyleParams } from '../../ui/shared/use-tpa-style-params';
import React, { useCallback } from 'react';
import { isNumberInputValid } from '../../ui/shared/numeric-input-utils';
import { useFocus } from '../../hooks/use-focus';
import { TextField as TPATextField, TextFieldTheme } from 'wix-ui-tpa/cssVars';
import classNames from 'classnames';
import { FIELD_ERROR_CLASS } from '../../field-error';
import { classes } from '../../ui/number-input-field/number-input-field-wut.st.css';
export const NumberInputWUT = _ref => {
  var _validation$number, _validation$number2, _validation$number3;
  let {
    value,
    validation,
    required,
    label,
    disabled,
    readOnly,
    placeholder,
    onChange,
    onBlur,
    onFocus,
    hasError,
    inputId,
    ariaDescribedBy
  } = _ref;
  const {
    isExperimentEnabled
  } = useExperiments();
  const useCSSVars = isExperimentEnabled(EXPERIMENTS.USE_CSS_VARS_ONLY);
  const multipleOf = (validation == null || (_validation$number = validation.number) == null ? void 0 : _validation$number.multipleOf) || 1;
  const maximum = validation == null || (_validation$number2 = validation.number) == null ? void 0 : _validation$number2.maximum;
  const minimum = validation == null || (_validation$number3 = validation.number) == null ? void 0 : _validation$number3.minimum;
  const forcedHover = useForcedState().includes(ForcedState.INPUT_FIELDS_HOVER);
  const {
    inputTheme,
    isBorderStyleNone
  } = useTpaStyleParams();
  const _value = typeof value === 'number' ? String(value) : value || '';
  const numberOnChange = useCallback(event => {
    const rawValue = event.target.value;
    if (rawValue === '') {
      // allow clear input
      onChange(rawValue);
      return;
    }
    const newValue = Number(rawValue);
    const validValue = isNumberInputValid(newValue, multipleOf) ? newValue : value;
    onChange(validValue);
  }, [onChange, multipleOf, value]);
  const {
    handleFocus,
    handleBlur,
    containerRef
  } = useFocus({
    onBlur,
    onFocus
  });
  return /*#__PURE__*/React.createElement("div", {
    ref: containerRef,
    onFocus: handleFocus,
    onBlur: handleBlur
  }, /*#__PURE__*/React.createElement(TPATextField, {
    id: inputId,
    type: "number",
    error: hasError,
    newErrorMessage: true,
    value: _value,
    className: classNames(classes.textField, {
      [FIELD_ERROR_CLASS]: hasError,
      [classes.noBorder]: isBorderStyleNone && !useCSSVars,
      [classes.hover]: forcedHover,
      [classes.theme]: useCSSVars
    }),
    onChange: numberOnChange,
    disabled: disabled,
    readOnly: readOnly,
    placeholder: placeholder,
    min: minimum ?? undefined,
    max: maximum ?? undefined,
    "aria-label": label,
    step: multipleOf,
    theme: useCSSVars ? TextFieldTheme.Box : inputTheme,
    "aria-describedby": ariaDescribedBy,
    "aria-invalid": hasError,
    required: required
  }));
};
//# sourceMappingURL=number-input-wut.js.map